module.exports = __webpack_public_path__ + "static/Crowns 3 intraoral after-a956d43035c442f3a019dbdfbba955dd.jpg";